// extracted by mini-css-extract-plugin
export default {"studioTypeContainer":"LongDropDownElement_studioTypeContainer__PH1rv"};